import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BUSINESS_INFO } from "../config";

export function CampaignBanner({ className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12 lg:items-center">
        {/* Venstre kolonne: Tekst og CTA */}
        <div className="lg:col-span-6 space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#dabeb9]/40 px-3.5 py-1 text-xs font-semibold uppercase tracking-wider text-black">
            <i className="fa-solid fa-certificate text-black" aria-hidden="true" />
            <span>Uddannet hundefrisør</span>
          </div>

          <h3 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight text-black leading-snug">
            Fejring af officiel åbning – Spar 20% på behandlinger
          </h3>

          <p className="text-base text-neutral-700 leading-relaxed">
            Med bestået afsluttende eksamen er jeg nu fuldt uddannet hundefrisør. Det fejrer vi i salonen med et stort åbningstilbud, hvor du sparer 20% på behandlinger frem til 31. januar 2027. Glæd dig til at forkæle din hund med masser af ro, nærvær og faglig stolthed.
          </p>

          <div className="pt-2 flex flex-wrap items-center gap-3">
            <a
              href={BUSINESS_INFO.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#dabeb9] px-6 py-3.5 text-sm font-medium tracking-wide text-black shadow-xs transition-colors hover:bg-[#c9a7a0] active:scale-98"
            >
              <i className="fa-solid fa-calendar-check text-black" aria-hidden="true" />
              <span>Book tid til åbningstilbud</span>
            </a>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 rounded-full border border-black bg-transparent px-5 py-3.5 text-sm font-medium tracking-wide text-black transition-colors hover:bg-black hover:text-white active:scale-98 whitespace-nowrap"
            >
              <i className="fa-solid fa-comment-dots text-current" aria-hidden="true" />
              <span>Spørgsmål? Kontakt os</span>
            </Link>
          </div>
        </div>

        {/* Højre kolonne: Fremhævet tilbudsboks */}
        <div className="lg:col-span-6">
          <div className="rounded-3xl border border-[#E2D2C3] bg-white p-7 sm:p-8 shadow-md">
            <div className="flex items-center justify-between gap-3 border-b border-neutral-100 pb-4">
              <span className="text-xs font-semibold uppercase tracking-wider text-black bg-[#dabeb9]/30 rounded-full px-3 py-1">
                Gælder frem til 31. jan 2027
              </span>
              <span className="text-xs text-neutral-600 font-medium">Hundens Pels og Pleje</span>
            </div>

            <div className="mt-5 space-y-3">
              <h4 className="font-heading text-xl sm:text-2xl font-medium text-black">
                Åbningstilbud: Spar 20% på behandlinger
              </h4>
              <p className="text-sm text-neutral-800 leading-relaxed">
                Som nyuddannet hundefrisør fejres salonens officielle start med 20% rabat på behandlinger frem til 31. januar 2027.
              </p>
              <div className="pt-2 text-xs text-neutral-700 space-y-2 border-t border-neutral-100">
                <div className="flex items-center justify-between">
                  <span className="font-medium text-black">Uddannelse:</span>
                  <span className="font-semibold text-black">Uddannet dyrepasser & hundefrisør</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-medium text-black">Fokus:</span>
                  <span className="font-semibold text-black">Ro, tryghed & god tid</span>
                </div>
                <p className="text-neutral-700 pt-1">
                  Der afsættes altid god tid til hver enkelt hund, så oplevelsen bliver tryg og stressfri.
                </p>
              </div>
            </div>

            <div className="mt-6 pt-4 border-t border-neutral-100">
              <a
                href={BUSINESS_INFO.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-semibold text-black hover:underline"
              >
                <span>Gå til online tidsbestilling</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

